
import Link from 'next/link';
import React from 'react';
import { FaTiktok } from 'react-icons/fa';
import ContactUs from '../ContactUs/ContactUs';

function Footer() {

  return (
    <>
      <footer className="theme-footer-three pt-100">
          <div className="top-footer">
            <div className="container">
              <div className="row ml-0 mx-0 justify-content-between">
                <div className="col-lg-4 col-12 footer-about-widget">
                  <Link href="/" className="logo cursor" style={{ cursor: 'pointer' }}><img src="../images/logo/Group 1157.svg" alt="logo" width='163' height='40' style={{ width: "160px" }} /></Link>
                </div>

                <div className="col-lg-2 col-md-6 footer-list">
                  <p className="footer-title">About us</p>
                  <ul>
                    <li><Link href="/en/user-aggrement" passHref><a>User Agreement</a></Link></li>
                    <li><Link href="/en/terms-and-conditions" passHref><a>Terms of Use</a></Link></li>
                    <li><Link href="/en/privacy-policy" passHref><a>Privacy Policy</a></Link></li>
                    <li><Link href="/en/cookies-policy" passHref><a>Cookies Policy</a></Link></li>
                    <li><Link href="/en/disclamier" passHref><a>Disclaimer</a></Link></li>
                    <li><Link href="https://blog.skatch.com/en/" passHref><a target='_blank'>Blogs</a></Link></li>
                  </ul>
                </div>
                <div className="col-lg-3 col-md-6 address-list">
                  <p className="footer-title" style={{fontSize:'18px',color:'#000',fontWeight:'600'}}>Contact Info</p>
                  <p className="font-rubik">Cairo, Egypt</p>
                  <ul className="info">
                    <li>
                      <a style={{textDecoration:'none'}} href='mailto:hello@skatch.com'>
                        {/* contact@skatch.com */}
                        hello@skatch.com
                      </a></li>
                    {/* <li><a style={{textDecoration:'none'}} className="mobile-num">+761 412 3224</a></li> */}
                  </ul>
                  <ul className="social-icon d-flex pt-15">
                    <li><a href="https://www.facebook.com/skatch.com.official" target='_blank'><i className="fa fa-facebook"></i></a></li>
                    <li><a href="https://www.instagram.com/skatch.com.official/" target='_blank'><i className="fa fa-instagram"></i></a></li>
                    <li><a href="https://www.linkedin.com/company/skatch" target='_blank'><i className="fa fa-linkedin"></i></a></li>
                    <li><a href="https://www.tiktok.com/@skatch.com" target='_blank'><FaTiktok></FaTiktok></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="bottom-footer-content">
              <div className="row ml-0 mx-0">
                <div className="col-lg-8 ml-auto">
                  <div className="d-md-flex align-items-center justify-content-between">
                    <ul className="order-md-last" style={{width:'100%'}}>
                      <li className='text-center1' style={{width:'100%',textAlign:'right',paddingRight:'5%'}}>Copyright @{new Date().getFullYear()} Skatch inc.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
        <ContactUs />
        <button className="scroll-top" aria-label='top' role='button'>
          <i className="fa fa-angle-up" aria-hidden="true"></i>
        </button>
    </>
  )
}
export default Footer;